module.exports = __webpack_public_path__ + "static/hero-62ae7836feb2ca5df64c619ee34b3a98.svg";